import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import WCButton from "@/components/WCButton";
import AnimateIn from "@/components/AnimateIn";
import { toast } from "sonner";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { register, loginWithGoogle } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Welcome to WrongConception.");
      navigate("/account");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="bg-black min-h-screen pt-[160px] md:pt-[200px] pb-24 px-6" data-testid="register-page">
      <div className="max-w-md mx-auto">
        <AnimateIn variant="fade">
          <h1 className="wc-heading text-white text-5xl md:text-6xl tracking-widest text-center">
            CREATE ACCOUNT
          </h1>
          <p className="text-white/60 text-center mt-4 text-sm">
            Join the ones who started questioning.
          </p>
        </AnimateIn>

        <form onSubmit={submit} className="mt-12 space-y-5" data-testid="register-form">
          <Field label="NAME" value={name} onChange={setName} testid="register-name" />
          <Field label="EMAIL" type="email" value={email} onChange={setEmail} testid="register-email" />
          <Field
            label="PASSWORD"
            type="password"
            value={password}
            onChange={setPassword}
            testid="register-password"
          />
          <WCButton
            type="submit"
            filled
            disabled={loading}
            className="w-full"
            data-testid="register-submit"
          >
            {loading ? "CREATING..." : "CREATE ACCOUNT"}
          </WCButton>
        </form>

        <div className="flex items-center gap-4 my-8">
          <div className="flex-1 h-px bg-white/20" />
          <span className="wc-label text-xs text-white/40">OR</span>
          <div className="flex-1 h-px bg-white/20" />
        </div>

        <button
          onClick={loginWithGoogle}
          className="wc-btn w-full flex items-center justify-center gap-3"
          data-testid="register-google"
        >
          <GoogleIcon />
          <span>Continue with Google</span>
        </button>

        <p className="text-center text-white/60 text-sm mt-10">
          Already have an account?{" "}
          <Link to="/login" className="text-white underline" data-testid="register-to-login">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}

const Field = ({ label, testid, onChange, ...rest }) => (
  <div>
    <label className="wc-label text-xs text-white block mb-2">{label}</label>
    <input
      {...rest}
      onChange={(e) => onChange(e.target.value)}
      required
      data-testid={testid}
      className="w-full bg-transparent border border-white/40 focus:border-white text-white outline-none px-5 py-4 text-base transition-colors"
    />
  </div>
);

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#fff" d="M44.5 20H24v8.5h11.8C34.9 33.1 30.1 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.7 1.1 7.9 3l6-6C34.6 5.5 29.6 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21c10.5 0 20-7.6 20-21 0-1.3-.2-2.6-.5-4z" />
  </svg>
);
